import React from 'react';
import './GlobalAppLoader.css';

/**
 * GlobalAppLoader - Instant splash loader that appears before any Firestore or component loads
 * This ensures users never see a blank white screen on first load
 */
export default function GlobalAppLoader() {
  return (
    <div 
      className="global-app-loader"
      role="status"
      aria-busy="true"
      aria-label="Loading Varaha Silks"
    >
      <div className="global-loader-content">
        <div className="global-loader-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <p className="global-loader-text">Loading...</p>
      </div>
    </div>
  );
}

